<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Inovação e segmentação</h2>
          <p>
            A JBS USA anuncia a aquisição da TriOak Foods, fortalecendo a
            capacidade da companhia de fornecer produtos suínos de alta
            qualidade aos consumidores americanos. Concluída a aquisição do
            controle societário da <strong>BioTech Foods</strong>, a Companhia
            anuncia também a escolha da cidade de Florianópolis para o JBS
            <strong>Biotech Innovation Center</strong>, centro de pesquisa,
            desenvolvimento e inovação em biotecnologia de alimentos e de
            proteína cultivada no Brasil. Em 2022, a JBS comunica a compra de
            duas fábricas de alimentos congelados no Oriente Médio, uma na
            Arábia Saudita e a outra nos Emirados Árabes. Também são celebradas
            parcerias estratégicas na região para distribuição nos dois países e
            no Kuwait.
          </p>
          <p>
            Ainda neste ano, como parte do compromisso
            <strong>Net Zero</strong>, a companhia lança a No Carbon, empresa de
            caminhões elétricos para reduzir as emissões, e também assume o
            compromisso de, até 2025, instalar energia solar em todas as lojas
            da Swift.
          </p>
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2022/2022-1.png"
            alt=""
            @click="showMultiple(0)"
            class="fistItem"
          />
          <img
            src="../assets/img/2022/2022-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2022/10/08/g/20221008-47107-spo-67-999-d7-not-ppkpqap.jpg'
              )
            "
            class="fistItem"
          />
          <img
            src="../assets/img/2022/2022-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2020/10/09/g/20201009-46378-spo-10-mrt-a10-not-hqawpek.jpg'
              )
            "
            class="fistItem"
          />

          <img
            src="../assets/img/2022/2022-4.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2023/01/21/g/20230121-47212-nac-59-999-d7-not-sxsgagp.jpg'
              )
            "
            class="secondItem"
          />
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
        <div class="formato__warpper__item--black">
          <h2>Novos rótulos e novos marcos</h2>
          <p>
            O governo federal cria novas regras para os rótulos dos alimentos.
            Eles buscam deixar mais fácil a vida do consumidor que quer saber se
            um produto tem alta quantidade de gordura, sódio, açúcar,
            carboidratos ou alguma outra questão.
          </p>
          <p>
            O Brasil bate recorde histórico na época em seu rebanho bovino, com
            224,6 milhões de cabeças de gado, enquanto os consumidores seguem
            cada vez mais exigentes, introduzindo novos hábitos de alimentação,
            como o caso do flexitarianismo, tendência que prega não a proibição,
            mas a redução do consumo de carne, em preocupação com o corpo e o
            planeta.
          </p>
          <div class="click" @click="handdleClick">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M17.0001 9C17.0001 13.4183 13.4184 17 9.00012 17C5.32473 16.755 1.4987 17 1.4987 16C1.5 15.5 0.998761 12.5697 1.00012 9C1.00012 4.58172 4.58184 1 9.00012 1C13.4184 1 17.0001 4.58172 17.0001 9Z"
                fill="white"
              />
              <path
                d="M17.8146 7.34176C17.0847 3.35835 13.7704 0.348083 9.70996 0.0311855C7.1172 -0.171378 4.82361 0.613296 2.89809 2.37268C-0.113394 5.12504 -0.863654 9.56944 1.05194 13.1759C1.1313 13.3258 1.14592 13.4568 1.09423 13.6197C0.887999 14.2717 0.691688 14.9275 0.49851 15.5837C0.453088 15.7388 0.414452 15.9017 0.409753 16.0625C0.381559 17.0466 1.31456 17.7665 2.27366 17.4966C2.97589 17.2987 3.67341 17.0847 4.37094 16.8696C4.51243 16.8257 4.62991 16.833 4.76148 16.9009C7.45866 18.2938 10.2148 18.3878 12.9235 17.0413C16.2107 15.4073 17.8093 12.6319 18.0004 8.94974C17.9435 8.44177 17.9143 7.88524 17.8146 7.34176ZM10.2644 16.5908C8.55455 16.8837 6.92507 16.6185 5.39061 15.8139C4.92281 15.5686 4.46492 15.5106 3.96057 15.6782C3.33614 15.886 2.7023 16.0635 2.07213 16.253C1.9557 16.288 1.81264 16.3637 1.7338 16.2321C1.6842 16.1491 1.68786 16.0087 1.71658 15.9074C1.90192 15.2559 2.08988 14.6043 2.29872 13.9595C2.45378 13.4819 2.40105 13.0459 2.16767 12.6037C-0.21677 8.08571 2.26792 2.62536 7.23937 1.45279C7.48633 1.39432 7.73746 1.34576 7.98911 1.31705C8.31908 1.27894 8.65218 1.26536 8.98372 1.24135C12.7815 1.25805 16.0159 4.02243 16.609 7.77195C17.27 11.9527 14.4527 15.8735 10.2644 16.5908Z"
                fill="#232378"
              />
              <path
                d="M8.97739 7.93735C7.88149 7.93735 6.78612 7.93892 5.69023 7.93631C5.31693 7.93579 5.05066 7.71338 5.01933 7.38918C4.98539 7.0326 5.20363 6.74912 5.55762 6.6943C5.61505 6.68542 5.67457 6.68438 5.73304 6.68438C7.8982 6.68438 10.0639 6.68333 12.229 6.68438C12.6472 6.68438 12.9255 6.91827 12.9417 7.27641C12.9589 7.65282 12.6958 7.93213 12.3032 7.93579C11.6511 7.94153 10.999 7.93735 10.3463 7.93787C9.89002 7.93787 9.4337 7.93735 8.97739 7.93735Z"
                fill="#232378"
              />
              <path
                d="M7.73896 10.0345C8.43649 10.0345 9.13454 10.0303 9.83207 10.0366C10.1244 10.0392 10.3662 10.2449 10.4252 10.5143C10.4857 10.7926 10.3594 11.0854 10.1051 11.2066C10.0028 11.2551 9.8801 11.2828 9.76681 11.2833C8.40412 11.2885 7.04143 11.2891 5.67874 11.2849C5.27934 11.2838 5.00993 11.0129 5.01568 10.6433C5.02142 10.2809 5.28612 10.0356 5.68501 10.034C6.36949 10.0309 7.05448 10.0329 7.73896 10.0329V10.0345Z"
                fill="#232378"
              />
            </svg>
            <strong><i>Clique</i> <i>aqui e </i> <i>leia mais</i></strong>
          </div>
        </div>
      </div>
    </div>
  </section>
  <Popup2
    texto="A diminuição do consumo de álcool é uma tendência mundial – vide as opções de vinhos e cervejas sem álcool que pipocam nas prateleiras. Em restaurantes e bares, o movimento começou lá atrás, com os chamados mocktails (drinques sem álcool). Hoje, está um passo à frente quem se preocupa em oferecer harmonização não alcoólica bem pensada, composta por bebidas que, de fato, fazem sentido com este ou aquele prato do menu."
    titulo="Harmonizações não alcoólicas ganham onHideespaço em restaurantes"
    :imagem1="require('../assets/img/2022/popup1.png')"
    linkimagem1="https://www.estadao.com.br/paladar/bebida/harmonizacoes-nao-alcoolicas-ganham-espaco-em-restaurantes/"
    :imagem2="require('../assets/img/2022/popup2.png')"
    linkimagem2="https://www.estadao.com.br/paladar/radar/tendencia-de-drinques-sem-alcool-veio-para-ficar-saiba-onde-degustar-os-coqueteis/"
    cor="rgba(130, 220, 100, 0.9)"
  />
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";
import Popup2 from "./Popup2.vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox, Popup2 },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    handdleClick() {
      this.$store.commit("TOGGLE_MODAL2", true);
      document.querySelector("body")?.classList.add("no-scroll");
    },
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    showMultiple(index) {
      this.imgsRef = [
        {
          src: require("@/assets/img/2022/2022-1-full.jpg"),
          title:
            "2022 - JBS Biotech Innovation Center, centro de pesquisa, desenvolvimento e inovação em biotecnologia de alimentos e de proteína cultivada no Brasil.",
        },
      ];
      this.indexRef = index; // index of imgList
      this.onShow();
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 160px;
    display: grid;
    grid-template-columns: 485px 275px 245px;
    justify-content: space-between;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;
    img {
      max-width: 100%;
      transition: 0.3s ease-in-out;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 0 20px;
      }
      &--image {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
        @include media("<=desktop") {
          align-content: center;
          padding: 0 20px;
        }
        .secondItem {
          margin-right: 70px;
          margin-top: -40px;
        }
        span {
          margin-top: -100px;
          top: 450px;
          width: 65px;
          color: color(cBlue4);
          @include media("<=desktop") {
            position: absolute;
            left: 20px;
            top: 350px;
          }
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cWhite);
            @include media("<=desktop") {
              background: color(cGreen);
            }
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        position: relative;
        @include media("<=desktop") {
          padding: 30px 20px;
          background: color(cGreen);
        }
        .click {
          max-width: 65px;
          cursor: pointer;
          strong {
            color: color(cWhite);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            display: block;
            max-width: 50px;
            i {
              font-style: normal;
              background: color(cBlue4);
              display: block;
              margin-bottom: 5px;
            }
          }
        }
        span {
          display: block;
          width: 65px;
          color: color(cBlue);

          strong {
            color: color(cWhite);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cBlue);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          margin-bottom: 30px;
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlack);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          span {
            width: initial;
            display: inline;
            font-weight: 400;
          }
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: color(cGreen);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
